import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '../../../services/api';
import { saveConfig } from './actions';

export function* fetchCartConfig({ payload }) {
  try {
    const { data } = yield call(
      api.get,
      `/api/v1/store/config?couple_id=${payload.coupleId}`
    );

    yield put(saveConfig(data.config));
  } catch (error) {
    console.log(error);
  }
}

export default all([takeLatest('@cart/FETCH_CONFIG', fetchCartConfig)]);
